import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** two people, group. Decorative line icon; always pair with a visible text label. */
export function UsersIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <circle cx="9.5" cy="8.5" r="3.3" />
      <path d="M3.5 20a6 6 0 0 1 12 0" />
      <path d="M15.8 5.4a3.3 3.3 0 0 1 0 6.2" />
      <path d="M17.5 14.3a6 6 0 0 1 3 5.7" />
    </IconSvg>
  )
}
